// extracted by mini-css-extract-plugin
export default {"softCover":"GDrAPKQPb50FFDoCgFyb","overlayCover":"Zksn4oxkjwtd40ciCTgj","overlayContent":"aYKRyce2OLBHmPOUdywv"};